module.exports = __webpack_public_path__ + "static/img/A61802_3.c2cc7f3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/homeContent/reportImage/A61802_3.png
// module id = +QU+
// module chunks = 1